import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { IProject } from "interfaces/project";
import { DateWithTooltip } from "components/DateWithTooltip";
import { UserCountWithTooltip } from "pages/Projects/UserCountWithTooltip";

interface ProjectDetailProps {
  selectedProject: IProject | undefined;
}

export const ProjectDetail = ({
  selectedProject
}: ProjectDetailProps): JSX.Element => {
  return (
    <Stack columnGap={3} rowGap={1} direction="row" flexWrap="wrap">
      <StyledColumn>
        <Typography>Owner</Typography>
        <UserCountWithTooltip users={selectedProject?.owner_data} />
      </StyledColumn>

      <StyledColumn>
        <Typography>Opened</Typography>
        <Typography variant="body2">
          <DateWithTooltip
            date={selectedProject?.create_date}
            defaultValue="Not set"
            showTime={false}
          />
        </Typography>
      </StyledColumn>

      <StyledColumn>
        <Typography>Due</Typography>
        <Typography variant="body2">
          <DateWithTooltip
            date={selectedProject?.target_completion_date}
            defaultValue="Not set"
            showTime={false}
          />
        </Typography>
      </StyledColumn>

      <StyledColumn>
        <Typography>{`Default ${selectedProject?.project_type} Assignee`}</Typography>
        <UserCountWithTooltip
          users={selectedProject?.default_action_assignee_data}
        />
      </StyledColumn>

      <StyledColumn>
        <Typography>Assignee</Typography>
        <UserCountWithTooltip
          users={selectedProject?.corresponding_action_assignees}
        />
      </StyledColumn>

      <StyledColumn>
        <Typography>Type</Typography>
        <Typography variant="body2">
          {selectedProject?.project_type ? (
            selectedProject.project_type
          ) : (
            <>&mdash;</>
          )}
        </Typography>
      </StyledColumn>

      <StyledColumn>
        <Typography>Last Updated</Typography>
        <Typography variant="body2">
          <DateWithTooltip
            date={selectedProject?.change_date}
            defaultValue="Not set"
            showTime
          />
        </Typography>
      </StyledColumn>

      <StyledColumn>
        <Typography>Description</Typography>
        <Tooltip title={selectedProject?.description}>
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
              whiteSpace: "wrap"
            }}
          >
            {selectedProject?.description ?? <>&mdash;</>}
          </Typography>
        </Tooltip>
      </StyledColumn>
    </Stack>
  );
};

const StyledColumn = styled(Box)`
  white-space: nowrap;
`;
StyledColumn.displayName = "StyledColumn";
